/*
 * File: language selector
 * File Created: 2021-05-12 5:55:02 pm
 * Author: huangxl (huangxl20@meicloud.com)
 * -----
 * Last Modified: 2021-06-12 3:40:17 pm
 * Modified By: huangxl (huangxl20@meicloud.com)
 */

<template>
  <div
    class="language-selector">
    <popover
      v-model="showPopover"
      trigger="click"
      :actions="actions"
      :get-container="getPopoverContainer"
      @select="onSelect"
    >
      <template #reference>
        <div class="container">
          <img src="../../assets/images/icons/earth.png" alt="" width="13" height="12">
          <span>{{ activeText }}</span>
          <img
            v-if="showPopover"
            src="../../assets/images/icons/arrow-up-blue.png"
            width="13"
            height="12">
          <img
            v-else
            src="../../assets/images/icons/arrow-down.png"
            alt=""
            width="13"
            height="12"
          >
        </div>
      </template>
    </popover>
  </div>
</template>

<script>
import { Popover } from 'vant'
export default {
  name: 'language-selector',
  components: {
    Popover
  },
  data () {
    return {
      active: this.$i18n.locale,
      showPopover: false,
      actions: [
        { text: '简体中文', value: 'zh-CN' },
        { text: 'English', value: 'en-US' },
        { text: '日本语', value: 'ja-JP' },
      ],
    }
  },
  computed: {
    activeText() {
      let activeVal = this.active,
          options = this.actions;
      return options.filter(option => option.value === activeVal).length
        && options.filter(option => option.value === activeVal)[0].text
    }
  },
  methods: {
    onSelect(item) {
      this.active = item.value
      this.$i18n.locale = item.value
      console.log('改变多语言---', this.$i18n.locale)
    },
    getPopoverContainer() {
      return document.querySelector('.language-selector')
    }
  }
}
</script>

<style lang='less' scoped>
  .language-selector {
    .container {
      width: 110px;
      display: flex;
      align-items: center;
      cursor: pointer;
      & > span {
        margin: 0 8px;
        font-size: 14px;
      }
      img {
        object-fit: cover;
      }
    }
    /deep/ .van-popover {
      &__action {
        padding: 0;
        &:hover {
          background: #E5E5E5;
        }
      }
      &__arrow {
        display: none;
      }
    }
    /deep/ .van-hairline--bottom::after {
      border-color: rgba(0,0,0,0.15);
    }
  }
</style>
